import React from 'react';

import toast from '../components/toast';

const APPEARANCE_TIME_IN_MILLISECONDS = 5000;

const renderSuccessToast = message => {
  toast.success(
    <p>{message}</p>,
    {
      time: APPEARANCE_TIME_IN_MILLISECONDS,
      iconName: 'icCheckWhite',
      iconAlt: 'Mensaje de éxito'
    }
  );
};

export default renderSuccessToast;
